import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavigationComponent } from './navigation/navigation.component';

// import { AuthGuard } from './_helpers/auth.guard';

import { HomeComponent } from './home/home.component';
import { SignupComponent } from './signup/signup.component';
import { SucessfulRegisterComponent } from './sucessful-register/sucessful-register.component';
import { AccessAccountComponent } from './access-account/access-account.component';
import { ConfirmPaymentsComponent } from './confirm-payments/confirm-payments.component';
import { ChitsComponent } from './chits/chits.component';
import { AuctionsComponent } from './auctions/auctions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { HeaderComponent } from './header/header.component';
import { InnerHeaderComponent } from './inner-header/inner-header.component';
import { AuthGuard } from './Services/Login/_helpers/auth.guard';

import { ChitWorksComponent } from './chit-works/chit-works.component';
import { WhyUsComponent } from './why-us/why-us.component';
import { CompanyComponent } from './company/company.component';
import { JoinChitComponent } from './join-chit/join-chit.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: 'Navigation', component: NavigationComponent },
  {
    path: '',
    component: NavigationComponent,
    children: [
      {
        path: '',
        component: ChitsComponent,
      },
      // {
      //   path: 'ChitWorks',
      //   component: ChitWorksComponent,
      // },
      // {
      //   path: 'Company',
      //   component: CompanyComponent,
      // },
      // {
      //   path: 'WhyUs',
      //   component: WhyUsComponent,
      // },
      // {
      //   path: 'JoinChit',
      //   component: JoinChitComponent,
      // },
      // {
      //   path: '',
      //   component: ChitsComponent,
      //   canActivate: [AuthGuard]
      //  },
      //  {
      //   path: '',
      //   component: TermsConditionsComponent,
      //   //canActivate: [AuthGuard]
      //  },
      //  {
      //   path: '',
      //   component: ContactComponent,
      //   //canActivate: [AuthGuard]
      //  },
      //  {
      //   path: 'PrivacyPolicy',
      //   component: PrivacyPolicyComponent,
      //   //canActivate: [AuthGuard]
      //  }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }


